import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Helmet } from 'react-helmet'
import { config } from 'config/config'
import { toKebabCase } from '@/modern/utils/transformString'
import { fetchFiltersCarLocation } from 'ducks/filtersCarLocation'
import { fetchFiltersBikeLocation } from 'ducks/filtersBikeLocation'
import { fetchDeclareSeo } from 'ducks/declareSeo'
import { setLocationSiteMap } from 'ducks/locationSiteMap'
import {
  parseLocationObj,
  returnStateLong,
  removeAccents,
  getUf,
  onClientSide,
} from 'utils/utils'
import { VEHICLE_TYPE, STATES } from 'utils/constants'

import Main from 'components/Main'
import Page from '@/modern/components/Page'
import NotFound from 'container/NotFound'

import * as S from './styles'

class LocationSiteMap extends Component {
  constructor(props) {
    super(props)

    const { match } = props
    const { vehicleType, stateLocation, page } = match.params

    this.state = {
      stateLocation,
      stateLocationLong: stateLocation ? returnStateLong(stateLocation) : '',
      isCitiesPage: !!stateLocation,
      vehicleType,
      page: (page && Number(page.replace(/^\D+/g, ''))) || 1,
      pageSize: 48,
      orderedElements: [],
      currentItems: undefined,
    }

    if (config.useSSR && !onClientSide()) {
      const { dispatch, declareSeo, locationSiteMap } = this.props
      const { pageSize, isCitiesPage, stateLocation, page } = this.state
      const dispatchVehicle = this.vehicleFetch()

      if (!declareSeo.fetched) {
        dispatch(fetchDeclareSeo('LocationSiteMap'))
      }

      if (!dispatchVehicle.fetched) {
        dispatch(dispatchVehicle.filter)
      }

      if (isCitiesPage && dispatchVehicle.fetched && !locationSiteMap.fetched) {
        const isValidPage = this.checkPageNumber(
          dispatchVehicle.result,
          stateLocation,
          pageSize,
          page
        )

        dispatch(
          setLocationSiteMap({
            isValidPage,
          })
        )
      }
    }

    this.relativePath = 'mapasite/'
    this.buildRbUrl = this.buildRbUrl.bind(this)
    this.buildPaginationUrl = this.buildPaginationUrl.bind(this)
    this.getCurrentPageItens = this.getCurrentPageItens.bind(this)
    this.paginationLinks = this.paginationLinks.bind(this)
  }

  componentDidMount() {
    const { dispatch } = this.props
    const dispatchVehicle = this.vehicleFetch()

    if (onClientSide() && !dispatchVehicle.fetched) {
      dispatch(dispatchVehicle.filter)
    }
  }

  componentDidUpdate(prevProps) {
    const { currentItems } = this.state
    const { result } = this.props[this.vehicleFetch().type]

    if (result.length !== 0) {
      const { match } = this.props
      const { isCitiesPage, stateLocationLong } = this.state
      const isNewPage = prevProps.match.params.page !== match.params.page

      const parsedLocationPayload = parseLocationObj(result, [])
      let listElementsName = parsedLocationPayload.map(state => state.name)

      if (isCitiesPage) {
        const state = removeAccents(stateLocationLong.trim().toUpperCase())
        const listElements = parsedLocationPayload.find(
          val => removeAccents(val.name.trim().toUpperCase()) === state
        ) || { items: [] }
        listElementsName = listElements.items.map(city => city.name)
      }

      const sorted = listElementsName.sort((a, b) => a.localeCompare(b))

      if ((isNewPage && isCitiesPage) || !currentItems) {
        const page = match.params.page
          ? Number(match.params.page.replace(/^\D+/g, ''))
          : 1

        this.getCurrentPageItens(sorted, page)
      }
    }
  }

  getCurrentPageItens(dataset, page) {
    const { pageSize } = this.state
    const lastIndex = page * pageSize
    const firstIndex = lastIndex - pageSize
    const currentItems = dataset.slice(firstIndex, lastIndex)

    this.setState({
      orderedElements: dataset,
      currentItems,
      page,
    })
  }

  handleClickPagination = (linkNumber, e) => {
    const { stateLocation, vehicleType } = this.state
    const { history } = this.props

    const url = `/${this.relativePath}${vehicleType}/${stateLocation}${
      linkNumber !== 1 ? `/pg${linkNumber}` : ''
    }`

    history.push(url)
    e.preventDefault()
  }

  paginationLinks(totalItems, pageSize = this.state.pageSize) {
    const totalPages = Math.ceil(totalItems / pageSize)
    if (totalPages === 1) return []

    const pageNumbers = []
    for (let i = 0; i < totalPages; i += 1) {
      pageNumbers.push(i + 1)
    }

    return pageNumbers
  }

  buildRbUrl(element = false) {
    const { stateLocation, vehicleType, isCitiesPage } = this.state

    if (isCitiesPage) {
      const cityDefinition = element ? `-${toKebabCase(element)}` : ''
      return `${config.urlApp}${vehicleType}/${stateLocation}${cityDefinition}`
    }

    return `${config.urlMapSite}/${vehicleType}/${getUf(element).toLowerCase()}`
  }

  buildPaginationUrl(linkNumber) {
    const { stateLocation, vehicleType } = this.state

    if (linkNumber === 1) {
      return `${config.urlApp}${this.relativePath}${vehicleType}/${stateLocation}`
    }

    return `${config.urlApp}${this.relativePath}${vehicleType}/${stateLocation}/pg${linkNumber}`
  }

  checkPageNumber(dataset, location = '', pageSize, page) {
    const stateLocationLong = returnStateLong(location)
    const urlState = removeAccents(stateLocationLong.trim().toUpperCase())
    const parsedLocationPayload = parseLocationObj(dataset, []).find(
      state => removeAccents(state.name.trim().toUpperCase()) === urlState
    )
    const totalPages =
      parsedLocationPayload && parsedLocationPayload.items
        ? Math.ceil(parsedLocationPayload.items.length / pageSize)
        : 1

    return parsedLocationPayload && page <= totalPages
  }

  vehicleFetch() {
    const { filtersCarLocation, filtersBikeLocation } = this.props
    const { vehicleType } = this.state

    const vehicleData = {
      [VEHICLE_TYPE.CAR]: {
        type: 'filtersCarLocation',
        filter: fetchFiltersCarLocation(config.urlApp),
        fetched: filtersCarLocation.fetched,
        result: filtersCarLocation.result,
      },
      [VEHICLE_TYPE.BIKE]: {
        type: 'filtersBikeLocation',
        filter: fetchFiltersBikeLocation(config.urlApp),
        fetched: filtersBikeLocation.fetched,
        result: filtersBikeLocation.result,
      },
    }

    return vehicleData[vehicleType]
  }

  renderHelmet() {
    const { match, location } = this.props
    const { vehicleType, stateLocation } = match.params

    const title = `Mapa do site - ${
      vehicleType === VEHICLE_TYPE.CAR ? 'Carros' : 'Motos'
    } por ${stateLocation ? 'cidade' : 'estado'}`
    const description = `Buscando ${
      vehicleType === VEHICLE_TYPE.CAR
        ? 'carros novos e usados'
        : 'motos novas e usadas'
    } ${
      stateLocation ? 'na sua cidade' : 'no seu estado'
    }? Encontre aqui através dos nossos mapas do site.`
    const canonical = `${config.urlApp.slice(0, -1)}${location.pathname}`

    return (
      <Fragment>
        <Helmet>
          <title>{title}</title>
          <meta name="language" content="pt-br" />
          <meta name="description" content={description} />
          <link rel="canonical"  />
          <link rel="alternate" hreflang="pt-BR" href={canonical} />
        </Helmet>
      </Fragment>
    )
  }

  render() {
    const {
      currentItems,
      isCitiesPage,
      vehicleType,
      stateLocation,
      orderedElements,
      page,
    } = this.state

    const { location, filtersCarLocation, filtersBikeLocation } = this.props

    return (
      <Fragment>
        {((currentItems && currentItems.length === 0) ||
          (filtersCarLocation && filtersCarLocation.error) ||
          (filtersBikeLocation && filtersBikeLocation.error)) && <NotFound />}
        <Page openFooter url={location}>
          {this.renderHelmet()}
          <Main className="LocationSiteMap">
            <S.Container>
              {!currentItems && <S.Title>Carregando...</S.Title>}
              {currentItems && currentItems.length > 0 && (
                <Fragment>
                  <S.Title>
                    {isCitiesPage ? (
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href={this.buildRbUrl()}
                      >
                        {`${
                          vehicleType === VEHICLE_TYPE.CAR ? 'Carros' : 'Motos'
                        } em ${
                          STATES.find(
                            stateItem =>
                              stateItem.uf === stateLocation.toUpperCase()
                          ).name
                        }`}
                      </a>
                    ) : (
                      `${
                        vehicleType === VEHICLE_TYPE.CAR ? 'Carros' : 'Motos'
                      } por Estado`
                    )}
                  </S.Title>
                  <S.LinkGroup>
                    {currentItems &&
                      currentItems.map(item => {
                        return (
                          <S.LinkList key={`${item}`}>
                            <S.LinkItem
                              rel="noreferrer"
                              href={this.buildRbUrl(item)}
                            >
                              {item}
                            </S.LinkItem>
                          </S.LinkList>
                        )
                      })}
                  </S.LinkGroup>
                  <S.Pagination>
                    {isCitiesPage &&
                      this.paginationLinks(orderedElements.length).map(
                        linkNumber => (
                          <S.LinkPage
                            key={linkNumber}
                            onClick={evt =>
                              this.handleClickPagination(linkNumber, evt)
                            }
                            href={this.buildPaginationUrl(linkNumber)}
                            className={`pageLink ${
                              linkNumber === page ? 'selected' : ''
                            }`}
                          >
                            {linkNumber}
                          </S.LinkPage>
                        )
                      )}
                  </S.Pagination>
                </Fragment>
              )}
            </S.Container>
          </Main>
        </Page>
      </Fragment>
    )
  }
}

export default connect(store => {
  return {
    filtersCarLocation: store.filtersCarLocationState,
    filtersBikeLocation: store.filtersBikeLocationState,
    locationSiteMap: store.locationSiteMapState,
    declareSeo: store.declareSeoState,
  }
})(withRouter(LocationSiteMap))
